import HTTP from '@/http-common'
export default {

    getSmsAll(id_company) { //eslint-disable-line
        let request = [
            `/v1/sms/sms`
        ]
        return HTTP.get(...request)
            .then((response) => Promise.resolve(response))
            .catch((error) => Promise.reject(error.response))
    },
    smsDelete(id) {
        HTTP.setHeader(true)
        let request = [
            `/v1/sms/delete/${id}`
        ]
        return new Promise((s, r) => {
            HTTP.delete(...request).then(s, r).then(() => { return }, () => { return })
        })
    },
    smsDeleteMultiple(data) {
        HTTP.setHeader(true)
        let request = [
            '/v1/sms/delete/multiple/',
            data
        ]
        return new Promise((resolve, reject) => {
            HTTP.post(...request).then(resolve).catch(reject)
        })
    },
    smsUpdateMultiple(data) {
        HTTP.setHeader(true)
        let request = [
            '/v1/sms/update/multiple/',
            data
        ]
        return new Promise((resolve, reject) => {
            HTTP.post(...request).then(resolve).catch(reject)
        })
    }
}